export default "__VITE_ASSET__ByDxib0w__"